import { METRIC_DEFINITIONS } from '../../../shared/constants/metrics';

const TeamOverviewCard = ({ team, metrics, onShowDetail }) => (
  <div className="team-card-section">
    <div className="team-card">
      <div className="team-card-header">
        <div
          className="team-color-indicator"
          style={{ backgroundColor: team.color || '#3bbddb' }}
        />
        <h4>{team.name}</h4>
      </div>
      <div className="team-stats">
        <p>Шагов: {team.steps ? team.steps.length : 0}</p>
        <p>Создана: {new Date(team.createdAt).toLocaleDateString()}</p>
        <p>Обновлена: {new Date(team.lastModified || team.updatedAt).toLocaleDateString()}</p>
      </div>
      <div className="team-metrics">
        {METRIC_DEFINITIONS.map(({ key, title }) => (
          <div key={key} className="metric">
            <span>{title}:</span>
            <span className="metric-value">{metrics[key].toFixed(1)}%</span>
          </div>
        ))}
      </div>
      <div className="team-card-actions">
        <button onClick={() => onShowDetail(team)} className="detail-view-btn" type="button">
          🔍 Просмотреть детально
        </button>
      </div>
    </div>
  </div>
);

export default TeamOverviewCard;
